import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const ChemicalTypeIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 11.986 13.01">
      <g id="Group_461" data-name="Group 461" transform="translate(-20.155)">
        <path
          id="Path_248"
          data-name="Path 248"
          d="M31.838,10.081,28.053,4.132V2.287a1.143,1.143,0,1,0,0-2.287H24.242a1.143,1.143,0,1,0,0,2.287V4.132l-3.785,5.948a1.9,1.9,0,0,0,1.608,2.929h8.167A1.9,1.9,0,0,0,31.838,10.081ZM24.944,4.448a.381.381,0,0,0,.06-.2V2.287a.381.381,0,1,0,0-.762h-.762a.381.381,0,1,1,0-.762h3.811a.381.381,0,1,1,0,.762h-.762a.381.381,0,1,0,0,.762V4.243a.381.381,0,0,0,.06.2l1.036,1.628a3.421,3.421,0,0,0-2.618.5l-1.191.794a2.656,2.656,0,0,1-1.77.433Zm5.286,7.8H22.064A1.143,1.143,0,0,1,21.1,10.49L22.364,8.5A3.409,3.409,0,0,0,25,8.007l1.191-.794a2.66,2.66,0,0,1,2.889-.046L31.2,10.49A1.143,1.143,0,0,1,30.231,12.247Z"
          transform="translate(0)"
          fill={props.color || theme.palette.text.primary}
        />
        <path
          id="Path_249"
          data-name="Path 249"
          d="M122.143,362a1.143,1.143,0,1,0,1.143,1.143A1.145,1.145,0,0,0,122.143,362Zm0,1.525a.381.381,0,1,1,.381-.381A.382.382,0,0,1,122.143,363.525Z"
          transform="translate(-98.283 -352.802)"
          fill={props.color || theme.palette.text.primary}
        />
        <path
          id="Path_250"
          data-name="Path 250"
          d="M272.143,302a1.143,1.143,0,1,0,1.143,1.143A1.145,1.145,0,0,0,272.143,302Zm0,1.525a.381.381,0,1,1,.381-.381A.382.382,0,0,1,272.143,303.525Z"
          transform="translate(-244.472 -294.326)"
          fill={props.color || theme.palette.text.primary}
        />
        <circle
          id="Ellipse_73"
          data-name="Ellipse 73"
          cx="0.381"
          cy="0.381"
          r="0.381"
          transform="translate(25.766 9.961)"
          fill={props.color || theme.palette.text.primary}
        />
        <circle
          id="Ellipse_74"
          data-name="Ellipse 74"
          cx="0.381"
          cy="0.381"
          r="0.381"
          transform="translate(28.815 9.961)"
          fill={props.color || theme.palette.text.primary}
        />
        <circle
          id="Ellipse_75"
          data-name="Ellipse 75"
          cx="0.381"
          cy="0.381"
          r="0.381"
          transform="translate(27.291 10.723)"
          fill={props.color || theme.palette.text.primary}
        />
      </g>
    </SvgIcon>
  );
};
